import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import ActiveLink from './ActiveLink'

@inject("designTemplateStore")
@observer
export default class CategoryViewer extends React.Component {
  static propTypes = {
    designTemplateStore: PropTypes.object.isRequired,
    buttonBackgroundColor: PropTypes.string,
    buttonForegroundColor: PropTypes.string,
    textColor: PropTypes.string,
  }

  handleCategorySelection = (category) => {
    const { designTemplateStore } = this.props
    designTemplateStore.activeCategory = category
  }

  render() {
    const { designTemplateStore, buttonBackgroundColor, buttonForegroundColor, textColor } = this.props
    const { categories, activeCategory } = designTemplateStore
    const { primaryColor, contrastColor } = designTemplateStore.franchise.attributes

    const activeStyle = {
      backgroundColor: buttonBackgroundColor || primaryColor,
      color: buttonForegroundColor || contrastColor,
      ...styles.category
    }
    const inactiveStyle = {
      backgroundColor: buttonForegroundColor || contrastColor,
      color: buttonBackgroundColor || primaryColor,
      ...styles.category
    }

    return (
      <div style={styles.wrapper}>
        <div style={styles.container}>
          <ActiveLink
            show={!!activeCategory}
            onClick={() => this.handleCategorySelection(null)}
            activeStyle={activeStyle}
            inactiveStyle={inactiveStyle}
          >
            All Categories
          </ActiveLink>
        </div>
        { categories.map(category =>
          <div key={category.id} style={styles.container}>
            <ActiveLink
              show={activeCategory !== category}
              onClick={() => this.handleCategorySelection(category)}
              activeStyle={activeStyle}
              inactiveStyle={inactiveStyle}
            >
              { category.attributes.name }
            </ActiveLink>
          </div>
        )}
      </div>
    )
  }
}

const styles = {
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 10
  },
  container: {
    padding: "2px 10px",
    marginBottom: 25
  },
  category: {
    padding: 10,
    textDecoration: "none"
  }
}
